export const cityLinkTitles = {
	climateControlled: 'Climate Controlled',
	'24HourAccess': '24 Hour Access',
	carStorage: 'Car Storage',
	boatStorage: 'Boat Storage',
	rvStorage: 'RV Storage',
};

export const amenityObject = {
	'climate-controlled': 'Climate-Controlled',
	'24-hour-access': '24-Hour',
	'drive-up-self-storage': 'Drive-Up',
	'free-truck-rental': 'Free Truck Rental',
	rv: 'RV',
	car: 'Car',
	boat: 'Boat',
	'': '',
};
